module.exports = __webpack_public_path__ + "img/category-popular.37bc83e4.png";